<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import { computed } from 'vue';
import StatusTagGroup from 'dashboard/components-next/tag/StatusTagGroup.vue';
import BuyerProfileTag from './BuyerProfileTag.vue';
import { activeBusinessContextFromLead } from '../utils/visitorInfoPresenter';

const props = defineProps({
  lead: { type: Object, default: () => ({}) },
  includeStage: { type: Boolean, default: false },
  size: { type: String, default: 'xs' },
});

const attrs = computed(
  () =>
    props.lead?.additional_attributes || props.lead?.additionalAttributes || {}
);
const buyerProfile = computed(
  () => props.lead?.buyer_profile || attrs.value.buyer_profile || {}
);

const createdAt = computed(
  () =>
    props.lead?.created_at ||
    props.lead?.createdAt ||
    props.lead?.first_contact_at ||
    attrs.value.first_contact_at
);

const isRecent = computed(() => {
  if (props.lead?.is_new || props.lead?.isNew) return true;
  if (!createdAt.value) return false;
  const created = new Date(createdAt.value);
  if (Number.isNaN(created.getTime())) return false;
  return Date.now() - created.getTime() <= 7 * 24 * 60 * 60 * 1000;
});

const isAgentReferral = computed(() => {
  const values = [
    props.lead?.characteristics,
    attrs.value.characteristics,
    props.lead?.lead_source,
    attrs.value.lead_source,
    attrs.value.origin_type,
  ]
    .flat()
    .filter(Boolean)
    .map(value => String(value).toUpperCase());

  return values.some(value => value.includes('AGENT_LEAD_REFERRAL'));
});

const isFirstVisit = computed(() => {
  if (props.lead?.is_first_visit || props.lead?.isFirstVisit) return true;
  const stats =
    props.lead?.lais_crm?.stats || attrs.value?.lais_crm?.stats || {};
  return (
    Number(
      stats.finished_visits_count || props.lead?.finished_visits_count || 0
    ) === 0
  );
});

const truthy = value =>
  value === true || String(value || '').toLowerCase() === 'true';

const isFirstPurchase = computed(() =>
  truthy(
    props.lead?.is_first_purchase ??
      props.lead?.isFirstPurchase ??
      buyerProfile.value.first_purchase ??
      buyerProfile.value.primeira_compra ??
      attrs.value.first_purchase ??
      attrs.value.primeira_compra
  )
);

const tags = computed(() =>
  [
    isRecent.value && { label: 'Novo', variant: 'success' },
    isAgentReferral.value && {
      label: 'Traz Quem Compra Pro',
      variant: 'new',
    },
    isFirstVisit.value && { label: 'Primeira visita', variant: 'success' },
    isFirstPurchase.value && {
      label: 'Primeira compra',
      variant: 'attention',
    },
    props.includeStage &&
      props.lead?.attendance_stage_label && {
        label: props.lead.attendance_stage_label,
        variant: 'scheduled',
      },
  ].filter(Boolean)
);

const businessContext = computed(() =>
  activeBusinessContextFromLead(props.lead)
);
</script>

<template>
  <div class="flex min-w-0 flex-wrap items-center gap-1.5">
    <StatusTagGroup v-if="tags.length" :tags="tags" :size="size" />
    <BuyerProfileTag
      :profile="lead.buyer_profile"
      :business-context="businessContext"
      :size="size"
    />
  </div>
</template>
